import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MetaData from '../MetaData';
import { Container, InputGroup } from 'react-bootstrap';
import SectionHeading from '../common/SectionHeading';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import { clearErrors, getOrderDetails, updateOrder } from '../../redux/actions/orderActions';
import Loader from '../common/Loader';
import { AiOutlineUser } from 'react-icons/ai';
import Select from 'react-select';
import { UPDATE_ORDER_RESET } from '../../redux/constants/orderConstants';

const ProcessOrder = () => {
    const { order, error, loading } = useSelector((state) => state.orderDetails);
    const { order: updateError, isUpdated } = useSelector((state) => state.order);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [status, setStatus] = useState('');

    const orderStateOptions = [];

    useEffect(() => {
        if (order && order.orderStatus?.toLowerCase() === 'processing') {
            orderStateOptions.push({
                label: 'Shipped',
                value: 'Shipped',
            });
        }
        if (order && order.orderStatus?.toLowerCase() === 'shipped') {
            orderStateOptions.push({
                label: 'Delivered',
                value: 'Delivered',
            });
        }
    }, [order]);

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (updateError) {
            toast.error(updateError);
            dispatch(clearErrors());
        }
        if (isUpdated) {
            toast.success('Order Updated Successfully');
            dispatch({ type: UPDATE_ORDER_RESET });
            navigate('/admin/orders');
        }

        dispatch(getOrderDetails(id));
    }, [error, updateError, isUpdated, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(
            updateOrder(id, {
                status: status.label,
            })
        );
    };

    return (
        <>
            <MetaData title={'Update Product'} />
            <Container>
                <div className='myOrdersPage section-padding-top section-padding-bottom'>
                    <Row>
                        <Col md={3}>
                            <Sidebar />
                        </Col>
                        <Col md={9}>
                            {loading ? (
                                <Loader />
                            ) : (
                                <div className='shippingContainer'>
                                    <div>
                                        <h4>Shipping Info</h4>
                                        <div className='confirmShippingArea'>
                                            <div>
                                                <p>Name:</p>
                                                <span>{order?.user.name}</span>
                                            </div>
                                            <div>
                                                <p>Phone:</p>
                                                <span>{order?.shippingInfo.phoneNo}</span>
                                            </div>
                                            <div>
                                                <p>Address:</p>
                                                <span>{`${order?.shippingInfo.address}, ${order?.shippingInfo.city}, ${order?.shippingInfo.state}, ${order?.shippingInfo.pinCode}, ${order?.shippingInfo.country}`}</span>
                                            </div>

                                            <h4 className='mt-5'>Payment</h4>
                                            <div className='order-summary'>
                                                <div>
                                                    <p
                                                        className={
                                                            order?.paymentInfo.status ===
                                                            'succeeded'
                                                                ? 'text-success'
                                                                : 'text-danger'
                                                        }
                                                    >
                                                        {order?.paymentInfo.status === 'succeeded'
                                                            ? 'PAID'
                                                            : 'NOT PAID'}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p>Amount:</p>
                                                    <span>Rs.{order?.totalPrice}</span>
                                                </div>
                                            </div>
                                            <h4 className='mt-5'>Order Status</h4>
                                            <div className='order-summary'>
                                                <div>
                                                    <p
                                                        className={
                                                            order?.orderStatus === 'Delivered'
                                                                ? 'text-success'
                                                                : 'text-danger'
                                                        }
                                                    >
                                                        {order?.orderStatus}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p>Amount:</p>
                                                    <span>Rs.{order?.totalPrice}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='confirmCartItems mt-5'>
                                            <h4>Your Cart Items</h4>
                                            <div className='confirmCartItemsContainer'>
                                                {order?.orderItems &&
                                                    order?.orderItems.map((item, i) => (
                                                        <div key={i} className='confirmCartItem'>
                                                            <img src={item.image} alt={item.name} />
                                                            <Link to={`/product/${item.product}`}>
                                                                {item.name}
                                                            </Link>
                                                            <span className='text-end'>
                                                                {item.quantity} X Rs.{item.price} ={' '}
                                                                <b>
                                                                    Rs.{item.price * item.quantity}
                                                                </b>
                                                            </span>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    </div>
                                    {order?.orderStatus.toLowerCase() !== 'delivered' && (
                                        <form onSubmit={handleSubmit}>
                                            <h4 className='text-center mb-4 noDataFound fw-light'>
                                                Process Order
                                            </h4>
                                            <InputGroup className='select-group mb-3'>
                                                <InputGroup.Text id='basic-addon1'>
                                                    <AiOutlineUser />
                                                </InputGroup.Text>
                                                <Select
                                                    className='custom-select'
                                                    value={status}
                                                    onChange={(e) => setStatus(e)}
                                                    options={orderStateOptions}
                                                />
                                            </InputGroup>
                                            <input
                                                type='submit'
                                                value='Update'
                                                className='submitBtn'
                                                disabled={loading || status === '' ? true : false}
                                            />
                                        </form>
                                    )}
                                </div>
                            )}
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default ProcessOrder;
